module.exports = {
      id: "palo-english-usage",
      viewBox: "0 0 230 78",
      url: "/" + "sprite-79b777a110ad18271a4fc79289e4208e.svg#palo-english",
      toString: function () {
        return this.url;
      }
    }